import { render, staticRenderFns } from "./GruposTurma.vue?vue&type=template&id=2ce4cf9a&"
import script from "./GruposTurma.vue?vue&type=script&lang=js&"
export * from "./GruposTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports